import { EditTableThemeSizeConfig } from './types';

const small: EditTableThemeSizeConfig = {
  EditTable: {},
};

export default small;
